import HostMatcher from './-private/host-matcher';
import { warn } from '@ember/debug';

// Mappings of Square domains to app sub-domains.
//
// TODO: while most of the entries in this array are general to Square,
// consumers may want to configure or add to this array (evidenced by the
// presence of one Dashboard specific mapping here).
const HOST_MATCHERS = [new HostMatcher(/^([^.]+\.)*squareup.com$/, () => {
  return 'app.squareup.com';
}), new HostMatcher(/^([^.]+\.)*squareupsandbox.com$/, () => {
  return 'app.squareupsandbox.com';
}), new HostMatcher(/^([^.]+\.)*squareupstaging.com$/, () => {
  return 'app.squareupstaging.com';
}), new HostMatcher(/^([^.]+\.)*squareup.com.([^.]+\.local)$/, match => {
  return `app.squareup.com.${match[2]}`;
}), new HostMatcher(/^localhost:(\d+)$/, match => `localhost:${match[1]}`)];
/**
 * Determines the app sub-domain for a given domain.
 *
 * This function allows easily configuring an app call to be sent to
 * the app sub-domain. For example:
 *
 * - `app.squareup.com` instead of `squareup.com`
 *
 * @param {string} host
 * @returns {string} The app sub-domain
 */
export function appHost(host, options) {
  if (options?.useSameHost) {
    return host;
  }
  for (const hostMatcher of HOST_MATCHERS) {
    const match = hostMatcher.match(host);
    if (match) {
      return match;
    }
  }
  warn(`cannot determine app host for host: ${host}`, false, {
    id: 'appHost'
  });
  return host;
}